import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';
import { SharedService } from '../services/shared.service';

@Injectable({
    providedIn: 'root',
})
export class AccessOrdersList implements CanActivate {
    constructor(private accountService: AccountService, private router: Router, private sharedService: SharedService) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this.sharedService.accessOrdersList) {
            this.router.navigate(['/']);
            return true;
        } else {
            return true;
        }
    }
}
